module.exports = __webpack_public_path__ + "img/safety-management-item2-1.5bd76a5d.png";